<template>
  <div class="ruleForm" v-loading="loadingtable">
    <el-form label-position="right" label-width="100px">
      <el-form-item label="企业名称" required="">
        <el-select v-model="corp_id" placeholder="请选择">
          <el-option v-for="item in corpidoptions" :key="item.corp_id" :label="item.corp_name" :value="item.corp_id" />
        </el-select>
      </el-form-item>
      <el-form-item label="规则名称" required="">
        <el-input v-model="group_type" placeholder="请输入规则名称" class="stra_box" />
      </el-form-item>
      <el-form-item label="规则类型" required="">
        <div class="ruletypes">
          <div class="cardrule" v-for="(item, index) in ruleTypes" :key="index" @click="selectRule(index)" :class="{ active: item.isActive }">
            <div>
              <span class="typerule">{{ item.name }}</span>
              <el-tag size="mini" v-show="index !== 2">弹性</el-tag>
            </div>
            <span class="description">{{ item.description[0] }}</span>
            <span class="description">{{ item.description[1] }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="打卡时间" required="">
        <el-button plain class="addbutton" @click="addTime">添加</el-button>
        <el-table :data="checkin_date" border style="width: 50%" v-show="checkin_date.length !== 0">
          <el-table-column prop="work_days" label="打卡日" width="250">
            <template slot-scope="scope">
              <div>{{ workdays(scope.row.work_days) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="checkin_time" label="上下班时间">
            <template slot-scope="scope">
              <div v-for="(work, i) in scope.row.checkin_time" :key="i">
                <span>上班 </span><span>{{ work.work_sec }}</span
                ><span> — </span><span>下班 </span><span>{{ work.off_work_sec }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="250">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>

    <div class="sava_box">
      <el-button type="primary" @click="goback">返回</el-button>
      <el-button type="warning" :disabled="loadingtable" @click="saveclick">保存</el-button>
    </div>

    <el-dialog title="打卡时间" :visible.sync="relevanceVisible" :destroy-on-close="true" width="36%" :close-on-click-modal="false">
      <relevaceTime ref="relevanceVisibleview" :FuallWorkDays="FuallWorkDays" @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import relevaceTime from './relevaceTime.vue'
import { createRules } from '@/api/tencentAccountIni'
import { filterCorplist } from '@/api/enterprisewechatControl'

export default {
  components: {
    relevaceTime
  },
  data() {
    return {
      corp_id: null,
      group_type: null,
      group_name: null,
      checkin_date: [],
      ruleTypes: [
        {
          name: '固定上下班',
          description: ['所有人按照相同时间打卡', '适用于办公室坐班，如朝九晚五'],
          isActive: false
        },
        {
          name: '排班上下班',
          description: ['不同人员按照各自排版打卡', '适用于工厂、门店等，如三班倒'],
          isActive: false
        },
        {
          name: '自由上下班',
          description: ['无时间限制，可随时打卡只统计旷工', '适用于销售、计时工种等'],
          isActive: false
        }
      ],
      relevanceVisible: false,
      loadingtable: false,
      isEdit: false,
      corpidoptions: [],
      FuallWorkDays: [],
      isEdited: false
    }
  },
  created() {
    // 检查路由参数中的 id 是否存在
    const { id } = this.$route.query
    if (id) {
      this.isEdited = true
    } else {
      this.isEdited = false
    }
  },
  computed: {
    workdays() {
      return days => {
        const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
        // 排序并去重
        const uniqueDays = Array.from(new Set(days)).sort((a, b) => a - b)
        let result = []
        let rangeStart = null
        let rangeEnd = null
        for (let i = 0; i < uniqueDays.length; i++) {
          if (rangeStart === null) {
            rangeStart = uniqueDays[i]
          }
          // 如果是最后一项或者当前项与下一个项不连续
          if (i === uniqueDays.length - 1 || uniqueDays[i] + 1 !== uniqueDays[i + 1]) {
            rangeEnd = uniqueDays[i]

            // 处理连续的日期
            if (rangeEnd - rangeStart >= 2) {
              result.push(`${weekDays[rangeStart]}至${weekDays[rangeEnd]}`)
            } else {
              // 处理连续少于三天的日期
              for (let j = rangeStart; j <= rangeEnd; j++) {
                result.push(weekDays[j])
              }
            }
            rangeStart = null
          }
        }
        return result.join('、')
      }
    }
  },
  mounted() {
    this.corpList()
  },
  methods: {
    //添加打卡时间
    addTime() {
      this.relevanceVisible = true
      const allWorkDays = this.checkin_date.flatMap(item => item.work_days)
      allWorkDays.sort((a, b) => a - b)
      this.FuallWorkDays = allWorkDays
    },

    updata(date, isEdit) {
      this.relevanceVisible = false
      this.$message({
        message: isEdit ? '编辑成功' : '添加成功',
        type: 'success'
      })

      if (isEdit) {
        const indexToUpdate = this.checkin_date.findIndex(item => item.id === date.id)
        if (indexToUpdate !== -1) {
          for (const key in date) {
            if (date.hasOwnProperty(key)) {
              this.checkin_date[indexToUpdate][key] = date[key]
            }
          }
        }
      } else {
        this.checkin_date.push({ id: this.checkin_date.length + 1, ...date })
      }

      console.log('checkin_date', this.checkin_date)
    },

    async corpList() {
      const data = await filterCorplist()
      this.corpidoptions = data.data
    },
    //打卡时间编辑
    handleEdit(row) {
      const allWorkDays = this.checkin_date.flatMap(item => item.work_days)
      const filteredWorkDays = allWorkDays.filter(day => !row.work_days.includes(day))
      filteredWorkDays.sort((a, b) => a - b)
      this.FuallWorkDays = filteredWorkDays //处理哪些日期禁选

      this.isEdit = true
      this.relevanceVisible = true
      this.$refs.relevanceVisibleview.send(row, this.isEdit)
    },
    handleDelete(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          const indexToDelete = this.checkin_date.findIndex(item => item.id === row.id)
          this.checkin_date.splice(indexToDelete, 1)
        })
        .catch(() => {})
    },
    // 处理卡片点击事件
    selectRule(index) {
      this.ruleTypes.forEach((item, i) => {
        if (i === index) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
      this.group_name = index + 1
    },
    goback() {
      this.$router.go(-1)
    },
    async saveclick() {
      if (!this.corp_id) {
        this.$message({
          message: '请选择企业名称',
          type: 'error'
        })
        return
      }
      if (!this.group_type) {
        this.$message({
          message: '请输入规则名称',
          type: 'error'
        })
        return
      }
      if (!this.group_name) {
        this.$message({
          message: '请选择规则类型',
          type: 'error'
        })
        return
      }
      if (!this.checkin_date.length) {
        this.$message({
          message: '请选择添加打卡时间',
          type: 'error'
        })
        return
      }

      const result = {
        corp_id: this.corp_id,
        group_type: this.group_type,
        group_name: this.group_name,
        checkin_date: this.checkin_date
      }

      try {
        const res = await createRules(result)
        this.$message({
          message: '创建成功',
          type: 'success'
        })
        this.$router.go(-1)
      } catch (error) {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style>
.ruleForm {
  margin-top: 50px;
  margin-left: 30px;
}
.stra_box {
  width: 300px;
}
.ruletypes {
  display: flex;
}
.cardrule {
  border: 1px solid #bdc0c5;
  width: 250px;
  height: 100px;
  border-radius: 5px;
  padding: 10px;
  margin-right: 10px;
}
.active {
  background-color: #e7f4ff;
  border: 1px solid #0082f0;
}
.typerule {
  font-weight: 600;
  font-size: 14px;
  margin-right: 5px;
}
.description {
  display: block;
  font-size: 12px;
  color: #606266;
  height: 16px;
  line-height: 16px;
}
.addbutton {
  margin-bottom: 10px;
}
.sava_box {
  position: fixed;
  bottom: 10px;
  left: 286px;
}
</style>